<template>
    <div>
        <div class="ban">
            <div class="ban_text">
                <p class="p1">NEWS UPDATES</p>
                <p class="p2">更多新闻动态都在这里</p>
            </div>
        </div>
        <div class="content_body">
            <h2>{{ con.title }}</h2>
            <div class="time">{{ con.create_datetime }}</div>
            <div class="body">
                <vue-markdown :source="con.body"></vue-markdown>
            </div>

        </div>
    </div>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import {
    getNewsDetailById
} from "@/api/api";
export default {
    data() {
        return {
            con: {},
            id: ''
        };
    },
    components: {
        VueMarkdown
    },
    mounted() {
        this.id = this.$route.query.id
        this.getBodyContent()
    },
    methods: {
        getBodyContent() {
            getNewsDetailById(this.id).then(res => {
                console.log(res)
                if (res.code == 1000) {
                    this.con = res.data
                } else {

                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.ban {
    background: url(../assets/banner_new.png) no-repeat center center;
    background-size: cover;
    height: 430px;
    overflow: hidden;
    // margin-top: 110px;

    .ban_text {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .p1 {
            font-size: 50px;
            font-weight: bold;
            color: #FFFFFF;
        }

        .p2 {
            font-size: 30px;
            color: #FFFFFF;
        }
    }
}

@media screen and (max-width: 750px) {
    .ban {
        height: 346px;
        margin-top: 206px;
    }
}

.content_body {
    width: 57%;
    height: auto;
    margin: 30px auto;

    h2 {
        font-size: 38px;
        font-weight: 500;
        line-height: 42px;
        color: #3D3D3D;
        margin: 70px 0 30px 0;
    }

    .time {
        font-size: 20px;
        line-height: 26px;
        color: #A4A4A4;
    }

    .body {
        width: 100%;
        margin: 38px auto;
        text-align: left;
        line-height: 30px;
        font-size: 18px;
        overflow: hidden;
    }
}

@media screen and (max-width: 750px) {
    .content_body {
        width: 80%;
    }
}</style>